import { Theme } from '@mui/material'

interface StickyHeaderStyleOptions {
  backgroundColor?: string
  zIndex?: number
  marginBottom?: number
  includeTopCover?: boolean
  top?: number | string
  fullBleed?: boolean
  paddingX?: number
}

const useStyles = {
  root: (theme: Theme, options: StickyHeaderStyleOptions) => ({
    position: 'sticky',
    top: options.top ?? 0,
    zIndex: options.zIndex ?? 1,
    ...(options.fullBleed !== false && {
      width: 'calc(100% + 32px)',
      marginX: -2,
      paddingX: options.paddingX ?? 2,
    }),
    backgroundColor: options.backgroundColor ?? theme.palette.ui.surfaceContainer,
    ...(options.marginBottom !== undefined && { marginBottom: options.marginBottom }),
    ...(options.includeTopCover && {
      '&::before': {
        content: '""',
        position: 'absolute',
        top: '-8px',
        left: 0,
        width: '100%',
        height: '8px',
        backgroundColor: options.backgroundColor ?? theme.palette.ui.surfaceContainer,
        pointerEvents: 'none',
      },
    }),
  }),
}

export type { StickyHeaderStyleOptions }
export default useStyles
